import React from 'react';
import PropTypes from 'prop-types';
import Lottie from 'lottie-react-web';
import { Button, Modal, ModalFooter } from 'react-bootstrap';

// Own constants/actions/components
import { add } from 'helpers/accumulator-sum';
import amLoader from '../../assets/am-loader.json';

const ModalConfirmation = ({ stateInitial, handleClose, itemsCart, isfeching, submitShopping }) => {
  const sumTotalPoints = () => {
    const arrayPoints = [];
    itemsCart.map((item) => {
      return arrayPoints.push(Number(item.points));
    });
    const sum = arrayPoints.reduce(add, 0);
    return sum.toLocaleString('es-MX');
  };

  return (
    <Modal show={stateInitial} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>¿Deseas finalizar tu pedido?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul className="list-unstyled text-tangaroa">
          {
            /* eslint-disable */
            itemsCart.length > 0 ? itemsCart.map((item, index) => (
              <li className="gift-label text-left gift-label mb-3" key={index}>
                {item.isGift === true ? (
                  <i className="fas fa-gift mr-2" />
                ) : '' }
                <span>{item.title}</span>

                {
                  item.type === 'FACE_TO_FACE' || item.type === 'MASTERCLASS' ||
                  item.type === 'TRAVEL' || item.type === 'TRAVEL_INTERNATIONAL' ? (
                    item.membersList.map((member, idx) => (
                      <div key={idx}>
                        <h3 className="text-tangaroa mt-20">
                          <i className="fas fa-user mr-2" />
                          {idx === 0 ? 'Titular de reservación' : `Acompañante ${idx}`}
                        </h3>
                        <p className="pl-25 mb-1">{member.name}</p>
                        <p className="pl-25 mb-1">{member.lastName}</p>
                        <p className="pl-25 mb-1">{member.middleName}</p>
                        <p className="pl-25 mb-1">{member.birthDate}</p>
                        <p className="pl-25 mb-1">{member.email}</p>
                        <p className="pl-25 mb-1">{member.phoneNumber}</p>
                      </div>
                    ))
                  ) : ''
                }
              </li>
            )) : ''
          }
        </ul>
      </Modal.Body>
      <ModalFooter className="m-0">
        <p className="text-tangaroa font-weight-bold mt-0">
          Valor total
        </p>
        <div className="text-primary font-weight-bold ml-4 mt-0">
          { sumTotalPoints() }
          <span className="ml-1">Puntos Aeroméxico Rewards</span>
        </div>
      </ModalFooter>
      <Modal.Footer className="border-top-0">
        {
          isfeching ? (
            <div className="loader-cp container">
              <Lottie
                width={50}
                options={{
                  animationData: amLoader,
                }} />
            </div>
          ) : (
            <>
              <Button variant="secondary" onClick={handleClose}>
                Regresar
              </Button>
              <Button variant="primary" onClick={submitShopping}>
                Finalizar
              </Button>
            </>
          )
        }
      </Modal.Footer>
    </Modal>
  );
}

ModalConfirmation.propTypes = {
  stateInitial: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  itemsCart: PropTypes.array.isRequired,
  isfeching: PropTypes.bool.isRequired,
  submitShopping: PropTypes.func.isRequired,
};

export default ModalConfirmation;
